import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { Paths } from "@constants/paths";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";

const LazyBankAccountStep = lazy(() => import("../BankAccountStep"));
const LazyBankLegalNameStep = lazy(() => import("../BankLegalNameStep"));
const LazyLegalNameStep = lazy(() => import("../LegalNameStep"));

interface PostLoginInfoStepProps {
  step: OnboardingDialogStep;
  stepNavigate: (step: OnboardingDialogStep) => void;
  handleClose: () => void;
  layout: _MemberSettingOnboardDialogLayout;
  callback?: () => void;
}

/**
 * Post login info prompt (persistent prompt)
 * Display appropriate prompt based on step
 */
const PostLoginInfoStep = ({ step, stepNavigate, handleClose, layout, callback }: PostLoginInfoStepProps) => {
  const routerNavigate = useNavigate();

  const handleOnUpdateSuccess = () => {
    if (callback) {
      callback();
    }
    routerNavigate(Paths.PRIVATE.HOME);
  };

  return (
    <>
      {/*Funding Mode: BankOnly*/}
      {[OnboardingDialogStep.UpdateBankAccount, OnboardingDialogStep.AddBankAccount].includes(step) && (
        <Suspense>
          <LazyBankAccountStep
            navigate={stepNavigate}
            onUpdateSuccess={handleOnUpdateSuccess}
            handleClose={handleClose}
            layout={layout}
            step={step}
          />
        </Suspense>
      )}

      {/*Funding Mode: EWalletOnly*/}
      {[OnboardingDialogStep.UpdateLegalName, OnboardingDialogStep.AddLegalName].includes(step) && (
        <Suspense>
          <LazyLegalNameStep
            navigate={stepNavigate}
            handleClose={handleClose}
            onUpdateSuccess={handleOnUpdateSuccess}
            layout={layout}
            step={step}
          />
        </Suspense>
      )}

      {/*Funding Mode: BankAndEWallet*/}
      {[OnboardingDialogStep.UpdateBankLegalName, OnboardingDialogStep.AddBankLegalName].includes(step) && (
        <Suspense>
          {/*Requirement changed: BankLegalNameStep -> LegalNameStep*/}
          {/* <LazyBankLegalNameStep
              navigate={stepNavigate}
              onUpdateSuccess={handleOnUpdateSuccess}
              handleClose={handleClose}
              layout={layout}
              step={step}
            /> */}
          <LazyLegalNameStep
            navigate={stepNavigate}
            handleClose={handleClose}
            onUpdateSuccess={handleOnUpdateSuccess}
            layout={layout}
            step={step}
          />
        </Suspense>
      )}
    </>
  );
};

export default PostLoginInfoStep;
